// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vdbi","col":"styles_col__2beH6"};